import { useForm, SubmitHandler } from 'react-hook-form';
import { useEffect } from 'react';
import { IFormData, Service } from 'data/Service';
import { COUNTRY_ISO } from 'constants/country';
import { useServiceRequest } from './useServiceRequest';
import { mapFormToServiceRequest } from 'utils/addOn';
import { useCountries } from './useCountries';
import { useCurrencies } from './useCurrencies';

export const useServiceForm = (service?: Service) => {

    const { updateServiceReq, createServiceReq } = useServiceRequest();
    const { countries } = useCountries();
    const { currencies } = useCurrencies();

    const formDefaultValues: IFormData = {
        id: service?.id || null,
        sku: service?.sku || '',
        name: service?.name || '',
        serviceTypeId: service?.serviceTypeId || 1,
        statusId: service?.statusId || 1,
        vendorId: service?.vendorId || 0,
        isForCanada: service?.servicePrices?.find(sp => sp?.country?.countryIso === COUNTRY_ISO.CA) ? true : false,
        isForUSA: service?.servicePrices?.find(sp => sp?.country?.countryIso === COUNTRY_ISO.US) ? true : false,
        canadaPrice: service?.servicePrices?.find(sp => sp?.country?.countryIso === COUNTRY_ISO.CA)?.pricePerUnit.toString() || null,
        usaPrice: service?.servicePrices?.find(sp => sp?.country?.countryIso === COUNTRY_ISO.US)?.pricePerUnit.toString() || null,
        unitOfMeasurementCaId: service?.servicePrices?.find(sp => sp?.country?.countryIso === COUNTRY_ISO.CA)?.unitOfMeasurementId || null,
        unitOfMeasurementUsaId: service?.servicePrices?.find(sp => sp?.country?.countryIso === COUNTRY_ISO.US)?.unitOfMeasurementId || null,
        version: 1,
        productVariants: service?.productVariants || [],
        servicePrices: service?.servicePrices || [],
        isOptional: false
    };

    const {
        control,
        handleSubmit,
        watch,
        formState: { errors, isValid, isDirty },
        reset,
        setValue,
        getValues,
        setError,
        clearErrors,
        trigger,

    } = useForm<IFormData>({
        defaultValues: formDefaultValues,
        mode: 'onBlur',
        shouldFocusError: true,
    });

    // Reset form if `service` prop changes
    useEffect(() => {
        reset(formDefaultValues);
    }, [service, reset]);

    const onSubmit: SubmitHandler<IFormData> = async (data) => {
        const payload = mapFormToServiceRequest(data, countries, currencies);
        data?.id ? updateServiceReq.run(payload) : createServiceReq.run(payload);
    };

    const isLoading = updateServiceReq.isLoading || createServiceReq.isLoading;

    return {
        control,
        handleSubmit,
        watch,
        errors,
        isValid,
        onSubmit,
        setValue,
        getValues,
        isLoading,
        setError,
        clearErrors,
        trigger,
        isDirty
    };
};
